import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./MenuItemMobile.scss";

const MenuItemMobile = ({
  icon,
  alias,
  link,
  children,
  openMenus,
  setMenuOpen,
  toggleMenu,
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const id = "id-" + alias;
  const isOpen = openMenus[id] ? true : false;

  return (
    <div className="menu-item-mobile">
      <div
        className={
          link === pathname ? "menu-item-wrapper active" : "menu-item-wrapper"
        }
        onClick={(e) => {
          if (children) {
            toggleMenu(id);
          } else {
            setMenuOpen(false);
            navigate(link);
          }
        }}
      >
        <span className="icon">{icon}</span>
        <span className={"name"}>{t(alias)}</span>
        {children ? (
          isOpen ? (
            <span className="dropdown-icon">keyboard_arrow_up</span>
          ) : (
            <span className="dropdown-icon">keyboard_arrow_down</span>
          )
        ) : (
          <span className="dropdown-icon" />
        )}
      </div>
      {children &&
        isOpen &&
        children.map((x, i) => (
          <MenuItemMobile
            key={i}
            icon={x.icon}
            alias={x.alias}
            link={x.link}
            children={x.children}
            openMenus={openMenus}
            toggleMenu={toggleMenu}
            setMenuOpen={setMenuOpen}
          />
        ))}
    </div>
  );
};

export default MenuItemMobile;
